import classNames from 'classnames';
import * as React from 'react';

type CardTab = {
	id: string;
	title: string;
	ariaLabel: string;
	onClick: () => void;
};

type PropsCardTabsList = {
	tabs: readonly CardTab[];
	activeTab: number;
	className?: string;
};

export const CardTabsList: React.FC<PropsCardTabsList> = ({
	tabs = [],
	activeTab,
	className,
	children,
}: React.PropsWithChildren<PropsCardTabsList>) => (
	<div
		className={classNames(
			'u-bg-neutral-light',
			'card-tabs__container',
			className,
		)}
	>
		<div className="card-tabs__nav-wrapper">
			<ul className="u-list-inline card-tabs__nav" role="tablist">
				{tabs.map(({ id, title, ariaLabel, onClick }, index) => (
					<li
						key={id}
						className={classNames('u-text-uppercase', 'card-tabs__nav-item', {
							'is-active': index === activeTab,
						})}
						id={id}
						aria-controls={ariaLabel}
					>
						<button
							type="button"
							className="u-text-uppercase card-tabs__link"
							onClick={onClick}
						>
							<span className="card-tabs__nav-title">{title}</span>
						</button>
					</li>
				))}
			</ul>
		</div>

		<div className="u-padding-top card-tabs__panel-container">{children}</div>
	</div>
);
